import { Component, OnInit } from '@angular/core';
import { AppSettings } from './../../configs/app-settings.config'
import { AppMetadataHandler } from './../../configs/app-metadata.handler'
import { AppOrganizationSettings } from './../../configs/app-organization-settings.config'
import { MultiLingualService } from '../../core/services'
import { AuthenticationService } from '../../core/authentication'
import { environment } from 'environments/environment'
import { MenuService } from '../../core/services/menu/menu.service'
import { SecureStorageService } from '../../core/utilities/secure-storage.service'
import { UserInfoService, CommonUtilty } from 'app/BaseFramework/core';
import { ApiRequestService } from 'app/BaseFramework/core';
import { DataTransformService } from 'app/ViewModules/shared-services';

export class MenuDataDO {
  id: any;
  menuName: any;
  route: any;
  sortOrder: any
  icon: any;
  submenu: any[];
  policyServingMenu: boolean
}

export class FinalMenuDataDO {
  module: any;
  menu: any;
}
@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit {

  constructor(private appSettings: AppSettings,
    private appOrganizationSettings: AppOrganizationSettings,
    public multiLingualService: MultiLingualService,
    public appMetadataHandler: AppMetadataHandler,
    private authenticationService: AuthenticationService,
    private menuService: MenuService,
    private secureStorageService: SecureStorageService,
    private userInfoService: UserInfoService,
    private commonUtilty: CommonUtilty,
    private apiRequestService: ApiRequestService,
    public dataTransformService: DataTransformService
  ) { }

  env = environment
  public storage: Storage = sessionStorage;
  menuData = new MenuDataDO;
  finalMenuDataDO = new FinalMenuDataDO();
  URLCallLogModal
  captureCheckList
  enableSpecificFeatures
  userInfoSrvc = this.userInfoService
  searchMenuTerm = null
  filteredMenu = []
  searchMenuAutoClose = () => {setTimeout(()=>this.searchMenuTerm='',250)};
  breadCrumb
  usersRole = null;

  get menuWidth(){
    // if(this.appMetadataHandler.featureFlags.enableQuickLeftRemarkPanel){
    //   return 300 
    // }
    // else 
    return 300
  }
  private demoMenuData = [
    {
      module: "All",
      menu: {
        menuName: "Claim Workbench",
        route: "/app/claims/inbox/workbench",
        icon: "file-protect",
        submenu: [
          //{ menuName: "Type of claims", route: "/app/claims", },
          //{ menuName: "Value of Claims",route: "/app/claims-inbox", },
        ]
      }
    },
    { module: "Claims", menu: { menuName: "Claim Initimation", route: "/app/claims/intimation/search", icon: "file-search", submenu: [] } },
    { module: "Claims", menu: { menuName: "Claim Registration ", route: "/app/claims/registration/search", icon: "file-done", submenu: [] } },
    { module: "Claims", menu: { menuName: "Claim Enquiry ", route: "/app/claims/inbox", icon: "file-unknown", submenu: [] } },
    { module: "Claims", menu: { menuName: "Upload Loose Docs", route: "/app/claims/inbox", icon: "upload", submenu: [] } },
    {
      module: "Claims", menu: {
        menuName: "Misc ", route: "/app/claims/inbox", icon: "appstore", submenu: [
          { menuName: "ExGratia Payment ", route: "/app/claims/inbox", },
          { menuName: "Repudiated Claim ", route: "/app/claims/inbox", },
          { menuName: "Claim Reversal  ", route: "/app/claims/inbox", },
        ]
      }
    },
    {
      module: "Claims", menu: {
        menuName: "Reports ", route: "/app/claims/inbox", icon: "file-pdf", submenu: [
          { menuName: "MIS", route: "/app/claims/inbox", },
          { menuName: "Adhoc", route: "/app/claims/inbox", },
          { menuName: "Scheduled Report", route: "/app/claims/inbox", },
        ]
      }
    },
    { module: "Claims", menu: { menuName: "Logout", route: "/login", icon: "logout", submenu: [] } },
    // { module: "All", menu: { menuName: "Workflow Configurator", route: "/app/claims/inbox/workflow-configurator", icon: "file-pdf", submenu: [] } },
    { module: "All", menu: { menuName: "Workflow Configurator", route: "/app/claims/inbox/search-config", icon: "file-pdf", submenu: [] } },

  ]

  /* Menu for BASE UI */
  private menuList_baseUI = [
    {
      module: "New Business",
      menu: {
        menuName: "Claims",
        route: "/app/claims",
        icon: "file-protect",
        submenu: [{
          menuName: "Type of claims",
          route: "/app/claims",
        },
        {
          menuName: "Value of Claims",
          route: "/app/claims-inbox",
        },
        ]
      }
    },
    {
      module: "New Business",
      menu: {
        menuName: "Partner",
        route: "/app/dash",
        icon: "cluster",
        submenu: []
      }
    },
    /*{
      module: "Product Configurator",
      menu: {
        menuName: "Org. Hierarchy",
        route: "/app/org-hierarchy",
        icon: "cluster",
        submenu: []
      }
    },*/
    {
      module: "New Business",
      menu: {
        menuName: "Agent Dash",
        route: "/app/dash",
        icon: "bar-chart",
        submenu: []
      }
    },
    {
      module: "Underwriting",
      menu: {
        menuName: "Inbox (UW)",
        route: "/app/inbox",
        icon: "file-protect",
        submenu: []
      }
    },
    /*{
      module: "Dev",
      menu: {
        menuName: "OCR",
        route: "/app/ocr-base",
        icon: "idcard",
        submenu: []
      }
    },
    {
      module: "Dev",
      menu: {
        menuName: "UI Sandbox",
        route: "/app/sandbox",
        icon: "deployment-unit",
        submenu: []
      }
    },*/
    {
      module: "New Business",
      menu: {
        menuName: "New Business",
        route: "/app/nb-capture-proposal",
        icon: "file-protect",
        submenu: [
          {
            menuName: "Search Proposal",
            lob: 'ALL',
            route: "/app/policyList",
            icon: "file-protect",
          },
          {
            menuName: "New Motor Proposal",
            lob: 'MOTOR',
            route: "/app/policyList",
            icon: "file-protect",
          },
          {
            menuName: "New Travel Proposal",
            route: "/app/policyList",
            lob: 'TRAVEL',
            icon: "file-protect",
          },
          {
            menuName: "New Property Proposal",
            route: "/app/policyList",
            lob: 'PROPERTY',
            icon: "file-protect",
          },
          {
            menuName: "New Health Proposal",
            route: "/app/nb-capture-proposal",
            lob: 'HEALTH',
            icon: "file-protect",
          }
        ]
      }
    },
    {
      module: "New Business",
      menu: {
        menuName: "Responsive Tables",
        route: "/app/responsive-tables",
        icon: "pic-center",
        submenu: []
      }
    },
    {
      module: "All",
      menu: {
        menuName: "Logout",
        route: "/login",
        icon: "logout",
        submenu: []
      }
    },

  ];

  private menuListOLD = [
    {
      module: "New Business",
      menu: {
        menuName: "Dashboard",
        route: "['/app/dash']",
        icon: "bar-chart",
        submenu: []
      }
    },
    {
      module: "Portal",
      menu: {
        menuName: "Leads",
        route: "['/app/leadList']",
        icon: "team",
        submenu: [{
          menuName: "All Leads",
          route: "['/app/leadList']",
          icon: "team",
        },
        {
          menuName: "Add Lead",
          route: "['/app/addLead']",
          icon: "team",
        }]
      }
    },
    {
      module: "Portal",
      menu: {
        menuName: "Quotation",
        route: "['/app/quoteList']",
        icon: "file-search",
        submenu: [{
          menuName: "All Quotations",
          route: "['/app/quoteList']",
          icon: "file-search",
        },
        {
          menuName: "Generate Quotation",
          route: "['/app/addLead']",
          icon: "file-search",
        }]
      }
    },
    {
      module: "Portal",
      menu: {
        menuName: "Policy",
        route: "['/app/policyList']",
        icon: "file-protect",
        submenu: [{
          menuName: "All Policies",
          route: "['/app/policyList']",
          icon: "file-protect",
        },
        {
          menuName: "Capture eApp",
          route: "['/app/captureEapp']",
          icon: "file-protect",
        }]
      }
    },
    {
      module: "New Business",
      menu: {
        menuName: "New Business",
        route: "/app/policyList",
        icon: "file-protect",
        submenu: [
          {
            menuName: "Motor",
            route: "/app/policyList",
            icon: "file-protect",
          },
          {
            menuName: "Travel",
            route: "/app/policyList",
            icon: "file-protect",
          },
          {
            menuName: "Property",
            route: "/app/policyList",
            icon: "file-protect",
          },
          {
            menuName: "Health",
            route: "/app/capture-proposal",
            icon: "file-protect",
          }
        ]
      }
    },
    {
      module: "Underwriting",
      menu: {
        menuName: "Underwriting",
        route: "['/app/policyList']",
        icon: "file-protect",
        submenu: [
          {
            menuName: "High Value Cases",
            route: "['/app/policyList']",
            icon: "file-protect",
          },
          {
            menuName: "Standard Cases",
            route: "['/app/policyList']",
            icon: "file-protect",
          },
          {
            menuName: "Low Value Cases",
            route: "['/app/policyList']",
            icon: "file-protect",
          },
          {
            menuName: "High Priority Cases",
            route: "['/app/policyList']",
            icon: "file-protect",
          },
          {
            menuName: "Low Priority Cases",
            route: "['/app/policyList']",
            icon: "file-protect",
          }
        ]
      }
    },
    {
      module: "All",
      menu: {
        menuName: "Logout",
        route: "['/app/logout']",
        icon: "logout",
        submenu: []
      }
    },

  ]
  showDevMenus: boolean = false;
  menuList = [];
  organizationMetaData = null;
  language = this.appMetadataHandler.defaultLanguage
  featureFlags = this.appMetadataHandler.featureFlags
  featureFlagsArray = []
  ngOnInit() {
    if (environment['hardcodedMenu']) {
      //this.getDemoMenu()
      this.getDemoProposedMenu();
    }
    else {
      this.getMenu();
    }

    let role = this.userInfoService.getUserRole();
    if(this.commonUtilty.isArrayIterable(role)){
      this.usersRole = role.toString();
    } else this.usersRole = role;
    
    this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData();

    this.featureFlagsArray = this.extractFeatureFlags(this.featureFlags);
  }

  private extractFeatureFlags(featureFlags) {
    let output = [];
    for (const key in featureFlags) {
      let item = { key: key, keyDescription: this.commonUtilty.splitCamelCaseAndApplyReplacements(key) };
      output.push(item);
    }
    return output;
  }

  changeLanguage(lang) {
    this.multiLingualService.setLanguage(lang);
  }

  getMenu() {
    this.menuService.getMenu().subscribe(resp => {
      console.log("MENU RESPONSE..");
      if (resp !== undefined) {
        console.log("MENU RESPONSE");
        var menuResponse = null;
        this.menuList = [];
        if (!this.env.production && this.showDevMenus) {
          this.menuList.push({
            module: "Product Configurator",
            menu: {
              menuName: "Demo Claim Workbench",
              route: "/app/claimsdemo/inbox",
              icon: "file-protect",
              submenu: []
            }
          })

          this.menuData = new MenuDataDO();
          // this.menuData.id = menuResponse[i].id;
          this.menuData.menuName = 'Generic File Upload';
          this.menuData.route = '/app/claims/fileupload';
          this.menuData.icon = 'file-protect';
          this.menuData.submenu = [];
          this.finalMenuDataDO = new FinalMenuDataDO();
          // this.finalMenuDataDO.module = menuResponse[i].applicationCd;
          this.finalMenuDataDO.menu = this.menuData;
          var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
          // this.menuList.push(objDummy);
          this.menuList = this.commonUtilty.uniquePushObjectInArray(this.menuList, objDummy, 'menuName', 'menu');
          this.menuData = new MenuDataDO();
          // this.menuData.id = menuResponse[i].id;
          this.menuData.menuName = 'Dispatch Details';
          this.menuData.route = '/app/claims/dispatchdetails';
          this.menuData.icon = 'file-protect';
          this.menuData.submenu = [];
          this.finalMenuDataDO = new FinalMenuDataDO();
          // this.finalMenuDataDO.module = menuResponse[i].applicationCd;
          this.finalMenuDataDO.menu = this.menuData;
          var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
          // this.menuList.push(objDummy);
          this.menuList = this.commonUtilty.uniquePushObjectInArray(this.menuList, objDummy, 'menuName', 'menu');
          this.menuData = new MenuDataDO();
          // this.menuData.id = menuResponse[i].id;
          this.menuData.menuName = 'Reports';
          this.menuData.route = '/app/claims/reports';
          this.menuData.icon = 'file-protect';
          this.menuData.submenu = [];
          this.finalMenuDataDO = new FinalMenuDataDO();
          // this.finalMenuDataDO.module = menuResponse[i].applicationCd;
          this.finalMenuDataDO.menu = this.menuData;
          var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
          // this.menuList.push(objDummy);
          this.menuList = this.commonUtilty.uniquePushObjectInArray(this.menuList, objDummy, 'menuName', 'menu');
          this.menuData = new MenuDataDO();
          // this.menuData.id = menuResponse[i].id;
          this.menuData.menuName = 'Investigation';
          this.menuData.route = '/app/claims/search-investigation';
          this.menuData.icon = 'file-protect';
          this.menuData.submenu = [];
          this.finalMenuDataDO = new FinalMenuDataDO();
          // this.finalMenuDataDO.module = menuResponse[i].applicationCd;
          this.finalMenuDataDO.menu = this.menuData;
          var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
          // this.menuList.push(objDummy);
          this.menuList = this.commonUtilty.uniquePushObjectInArray(this.menuList, objDummy, 'menuName', 'menu');
          this.menuData = new MenuDataDO();
          // this.menuData.id = menuResponse[i].id;
          this.menuData.menuName = 'Dashboard';
          this.menuData.route = '/app/claims/inbox/fwa-dashboard';
          this.menuData.icon = 'cluster';
          this.menuData.submenu = [];
          this.finalMenuDataDO = new FinalMenuDataDO();
          // this.finalMenuDataDO.module = menuResponse[i].applicationCd;
          this.finalMenuDataDO.menu = this.menuData;
          var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
          // this.menuList.push(objDummy);
          this.menuList = this.commonUtilty.uniquePushObjectInArray(this.menuList, objDummy, 'menuName', 'menu');

          this.menuData = new MenuDataDO();
          // this.menuData.id = menuResponse[i].id;
          this.menuData.menuName = 'Claims Dashboard';
          this.menuData.route = '/app/claims/inbox/claims-dashboard';
          this.menuData.icon = 'cluster';
          this.menuData.submenu = [];
          this.finalMenuDataDO = new FinalMenuDataDO();
          // this.finalMenuDataDO.module = menuResponse[i].applicationCd;
          this.finalMenuDataDO.menu = this.menuData;
          var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
          // this.menuList.push(objDummy);
          this.menuList = this.commonUtilty.uniquePushObjectInArray(this.menuList, objDummy, 'menuName', 'menu');
        }
        menuResponse = resp.data;
        this.storage.setItem("userPrivileges", JSON.stringify(menuResponse));
        if (menuResponse)
          menuResponse = menuResponse.sort((a, b) => a.sortOrder - b.sortOrder);

        for (var i = 0; i < menuResponse.length; i++) {
          if (menuResponse[i].parentId === 0) {
            this.menuData = new MenuDataDO();
            this.menuData.id = menuResponse[i].id;
            this.menuData.menuName = menuResponse[i].privilegeCd;
            this.menuData.sortOrder = menuResponse[i].sortOrder;
            this.menuData.route = menuResponse[i].url;
            this.menuData.icon = menuResponse[i].icon;
            this.menuData.submenu = [];
            this.finalMenuDataDO = new FinalMenuDataDO();
            this.finalMenuDataDO.module = menuResponse[i].applicationCd;
            this.finalMenuDataDO.menu = this.menuData;
            var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
            // this.menuList.push(objDummy);
            this.menuList = this.commonUtilty.uniquePushObjectInArray(this.menuList, objDummy, 'menuName', 'menu');
          }
        }
        for (var i = 0; i < menuResponse.length; i++) {
          for (var j = 0; j < this.menuList.length; j++) {

            if (menuResponse[i].parentId == this.menuList[j].menu.id) {
              this.menuData = new MenuDataDO();
              this.menuData.id = menuResponse[i].id;
              this.menuData.menuName = menuResponse[i].privilegeCd;

              this.menuData.route = menuResponse[i].url;
              this.menuData.submenu = [];
              var objDummy = JSON.parse(JSON.stringify(this.menuData));
              this.menuList[j].menu.submenu.push(objDummy);
            }

            for (var k = 0; k < this.menuList[j].menu.submenu.length; k++) {
              if (menuResponse[i].parentId == this.menuList[j].menu.submenu[k].id) {
                this.menuData = new MenuDataDO();
                this.menuData.id = menuResponse[i].id;
                this.menuData.menuName = menuResponse[i].privilegeCd;
                this.menuData.sortOrder = menuResponse[i].sortOrder;
                this.menuData.route = menuResponse[i].url;
                this.menuData.submenu = [];
                var objDummy = JSON.parse(JSON.stringify(this.menuData))
                this.menuList[j].menu.submenu[k].submenu.push(objDummy);
              }
            }

          }

        }

        // Hard coded menu function
        let hardCodedMenuList
        hardCodedMenuList = this.pushHardCodedMenusList()
        this.menuList = [...this.menuList, ...hardCodedMenuList];

        var menuItems = this.menuList.filter(menu => {
          return menu.menu.menuName != 'Logout'
        });
        var footerItems = this.menuList.filter(menu => {
          return menu.menu.menuName == 'Logout'
        });

        this.menuList = [];
        this.menuList.push(...menuItems);
        this.menuList.push(...footerItems);
        
        //custom menu fetch function
        let customeMenuList
        customeMenuList = this.customApiCallForMenus()
        this.menuList = [...this.menuList, ...customeMenuList];
      }
    },
      errResponse => {
        switch (errResponse.status) {

        }
      }
    );
    var list = [];
    var topItems = []
    var allitems = this.demoMenuData.filter(menu => {
      return menu.module === 'All' && menu.menu.menuName != 'Logout'
    });

    topItems.push(...allitems)
    var moduleSpecificItems = []
    var operationalModules = this.appSettings.operationalModules;
    var supportedLOBs = this.appSettings.LineOfBusiness
    operationalModules.forEach(opmodule => {

      var items = this.demoMenuData.filter(menu => {
        return menu.module === opmodule
          && menu.menu.menuName != 'Logout'
          && menu.menu.menuName != 'Agent Dash'
      })

      var topItemsFromModules = this.demoMenuData.filter(menu => {
        return menu.module === opmodule
          && menu.menu.menuName === 'Agent Dash'
      })

      topItems.push(...topItemsFromModules);
      moduleSpecificItems.push(...items);
    })
    var footerItems = this.demoMenuData.filter(menu => {
      return menu.menu.menuName === 'Logout'
    });
  }
  pushHardCodedMenusList(){
    let hardCodedMenuList = []
    hardCodedMenuList.push({
      module: "Product Configurator",
      menu: {
        menuName: "FWA Dashboard",
        route: "/app/claims/inbox/fwa-dashboard",
        icon: "cluster",
        submenu: []
      }
    })
    if (this.env.dummyDashboard) {
      hardCodedMenuList.push({
        module: "Product Configurator",
        menu: {
          menuName: "Dashboard",
          route: "/app/claims/inbox/claims-dashboard",
          icon: "cluster",
          submenu: []
        }
      })

      hardCodedMenuList.push({
        module: "Product Configurator",
        menu: {
          menuName: "Brabch Enquiry",
          route: "/app/claims/intimation/search-branchenquiry",
          icon: "cluster",
          submenu: []
        }
      })
    }
    return hardCodedMenuList;
  }
  customApiCallForMenus(){
    this.apiRequestService.getCallWithAPIMapper("dashboardFetchMenuCd").subscribe(resp => {
      if (this.commonUtilty.isArrayIterable(resp.dashboards) && resp.dashboards.length > 0) {

        let generatedSubmenus = resp.dashboards.map((dashboard) => {
          return { menuName: dashboard.dashboardName, route: `/app/dashboard/${dashboard.guid}` }
        })
        const dashboardMenu = {
          module: "Product Configurator",
          menu: {
            menuName: "Dashboards",
            route: "/app/claimsdemo/dashboards",
            icon: "file-protect",
            submenu: [...generatedSubmenus],
            sortOrder: 49
          }
        }
        const updatedMenus = []
        updatedMenus.push(dashboardMenu);
        return updatedMenus;
      }
    })
  }

  fetchedAPILog = []
  refreshAPILog() {
    this.fetchedAPILog = []
    let urlSLS = this.secureStorageService.get('URLSLS');
    let parsedURLSLS
    try {
      parsedURLSLS = JSON.parse(urlSLS);
    }
    catch {
      parsedURLSLS = null
    }

    if (parsedURLSLS) {
      for (const key in parsedURLSLS) {
        let item = { url: key, count: parsedURLSLS[key] }
        this.fetchedAPILog.push(item)
      }
    }


  }

  clearAPILog() {
    this.fetchedAPILog = []
    this.secureStorageService.remove('URLSLS')
  }

  getDemoProposedMenu(){
     let menuResponse = this.appMetadataHandler.mockData.menu;
     let userInfo = this.userInfoService.getUserInfo();
    let userRole = null;
     let userRoleDO = userInfo.userRoleDOList.find(item => true);
      userRole = userRoleDO.roleId;
     if(userRoleDO.roleId != 'UNDERWRITER'){
      menuResponse = menuResponse.filter(item => item['privilegeCd'] != "UW Dashboard");
     }
        for (var i = 0; i < menuResponse.length; i++) {
          if (menuResponse[i]['parentId'] === 0) {
            this.menuData = new MenuDataDO();
            this.menuData.id = menuResponse[i]['id'];
            this.menuData.menuName = menuResponse[i]['privilegeCd'];
            this.menuData.sortOrder = menuResponse[i]['sortOrder'];
            this.menuData.route = menuResponse[i]['url'];
            this.menuData.icon = menuResponse[i]['icon'];
            this.menuData.policyServingMenu = menuResponse[i]['policyServingMenu'];
            this.menuData.submenu = [];
            this.finalMenuDataDO = new FinalMenuDataDO();
            this.finalMenuDataDO.module = menuResponse[i]['applicationCd'];
            this.finalMenuDataDO.menu = this.menuData;
            var objDummy = JSON.parse(JSON.stringify(this.finalMenuDataDO));
            this.menuList.push(objDummy);
          }
        }

        this.menuList.forEach((module, i) => {
          this.menuList[i]['sortOrder'] = module.menu.sortOrder
        });

        if(!this.appMetadataHandler.featureFlags['showPolicyServingMenu']){
          this.menuList = this.menuList.filter(item => !item.menu.policyServingMenu);
        }
        this.menuList = this.commonUtilty.sortObject('sortOrder', this.menuList, 'asc')
  }

  getDemoMenu() {
    var list = [];
    var topItems = []
    var allitems = this.demoMenuData.filter(menu => {
      return menu.module === 'All' && menu.menu.menuName != 'Logout'
    });

    topItems.push(...allitems)

    var moduleSpecificItems = []
    var operationalModules = this.appSettings.operationalModules;
    var supportedLOBs = this.appSettings.LineOfBusiness
    operationalModules.forEach(opmodule => {

      var items = this.demoMenuData.filter(menu => {
        return menu.module === opmodule
          && menu.menu.menuName != 'Logout'
          && menu.menu.menuName != 'Agent Dash'
      })

      var topItemsFromModules = this.demoMenuData.filter(menu => {
        return menu.module === opmodule
          && menu.menu.menuName === 'Agent Dash'
      })

      topItems.push(...topItemsFromModules);
      moduleSpecificItems.push(...items);
    })

    //Filter Supported LOBS

    // moduleSpecificItems.forEach(moduleItem => {
    //   var filteredsubmenu = [];
    //   moduleItem.menu.submenu.forEach(submenu => {

    //     var filtered = supportedLOBs.filter(lob => lob === submenu.lob)
    //     filteredsubmenu.push(...filtered)
    //   })
    //   moduleItem.menu.submenu = filteredsubmenu;
    // })


    var footerItems = this.demoMenuData.filter(menu => {
      return menu.menu.menuName === 'Logout'
    });

    this.menuList = [];
    if (!this.env.production) {
      this.menuList.push({
        module: "All",
        menu: {
          menuName: "Demo Claim Workbench",
          route: "/app/claimsdemo/inbox",
          icon: "file-protect",
          submenu: []
        }
      })
    }
    this.menuList.push(...topItems);
    this.menuList.push(...moduleSpecificItems);
    this.menuList.push(...footerItems);

  }

  isCollapsed = false;
  triggerTemplate = null;

  /* ChatBot */
  chatBot = false;
  closeChatBot(): void { this.chatBot = false }

  /* Performance Modal */
  perfModalisVisible = false;
  showPerformanceModal(): void { this.perfModalisVisible = !this.perfModalisVisible }

  mode = null; // MENU -> true = vertical; else inline
  /* Logout */
  logout() {
  //  this.authenticationService.logout();
  this.apiRequestService.logout();
  }

  filterMenu(){
    let mainMenu = []
    let subMenu = []
    mainMenu = this.menuList.filter(val=>{
      if( val.menu.submenu.length === 0)
      return val.menu.menuName.toLowerCase().includes(this.searchMenuTerm.toLowerCase())
    })
    this.menuList.forEach(val=>{
     let tempSubMenu = val.menu.submenu.filter(sub=>sub.menuName.toLowerCase().includes(this.searchMenuTerm.toLowerCase()))
      subMenu = subMenu.concat(tempSubMenu)
    })
    this.filteredMenu = mainMenu.concat(subMenu)
    console.log(this.filteredMenu)
  }

  
  getLoggedInCompany() {
    try {
      let companyInfoString: string = this.storage.getItem('currentCompany');
      if (companyInfoString) {
        return JSON.parse(companyInfoString);
      }
      else {
        return null;
      }
    }
    catch (e) {
      return null;
    }
  }
}
